<template :key="componentKey">
  <div>
    <v-row justify="center">
      <v-dialog v-model="dialogCreated" persistent max-width="600">
        <v-card>
          <v-card-title class="headline">
            Ouverture de dossier acceptée
          </v-card-title>
          <v-card-text>
            <p>
              Votre accès à la demande d'agrément de maître de stage a été
              accepté.
            </p>
            <p>
              Un courriel contenant le lien d'accès au formulaire de demande
              vous a été envoyé à l'adresse <b>{{ this.email }}</b>
            </p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="
              clearForm();
              dialogCreated = false;
            ">
              D'accord
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="avertissement" persistent max-width="600">
        <v-card>
          <v-card-title class="headline">
            Application de test
          </v-card-title>
          <v-card-text>
            <p>
              Afin de procéder à l'ouverture d'un dossier, merci de saisir un
              numéro de SIRET correspondant à une officine des Hauts-de-France.
            </p>
            <p>
              <b>Cette application étant mise à jour régulièrement, il convient,
                avant chaque phase de test, de vider le cache de votre
                navigateur afin d'avoir accès aux dernières évolutions de
                celle-ci.
              </b>
              <br />=> Pour cela, appuyez simultanément sur les touches [Ctrl]
              et [F5] de votre clavier, puis, une fois la page rechargée, vous
              pouvez fermer cette boîte de dialogue et utliser l'application.
            </p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="avertissement = false">
              Fermer
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row>
      <v-col cols="12">
        <BaseBlock title="Accès à la demande d'agrément">
          <v-alert v-if="isServiceIndisponible" type="warning">
            En raison de la mise en œuvre de la réforme du <b>DES de Pharmacie Officine</b>, la plateforme de dépôt des demandes d'agrément est temporairement <b>indisponible</b>.<br/><br/>Une nouvelle version actualisée sera prochainement mise en ligne.<br/><br/>Merci de votre compréhension et de votre patience.
          </v-alert>
          <v-form v-else ref="form" v-model="valid">
            <v-container>
              <v-row>
                <v-col cols="12" md="1"> </v-col>
                <v-col cols="12" md="4">
                  <p class="subtitle-1 text-left font-weight-bold">
                    Vos informations de contact :
                  </p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="1"> </v-col>
                <v-col cols="12" md="4">
                  <v-text-field v-model="nom" :rules="nomRules" label="Nom" required></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field v-model="prenom" :rules="prenomRules" label="Prénom" required></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" md="1"> </v-col>
                <v-col cols="12" md="8">
                  <v-text-field v-model="email" :rules="emailRules" label="Adresse courriel de contact" required>
                  </v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" md="1"> </v-col>
                <v-col cols="12" md="8">
                  <v-text-field v-model="siret" :rules="siretRules" label="Numéro de SIRET de l'officine" required>
                  </v-text-field>
                </v-col>
              </v-row>

              <div id="conditions-experience" v-bind:class="{ 'red--text': !isConditionsExperience }">
                <v-row>
                  <v-col cols="12" md="1"> </v-col>
                  <v-col cols="12" md="8">
                    <p class="subtitle-1 text-left font-weight-bold">
                      Les conditions d'expérience* :
                    </p>
                    <p class="text-sm-left body-2 font-italic">
                      * Si vous ne remplissez pas ces 2 conditions, votre
                      dossier n’est pas recevable
                      <br />
                      <span class="grey--text">(Article 21 de l’Arrêté du 8 avril 2013 relatif au
                        régime des études en vue du diplôme d'Etat de docteur en
                        pharmacie).</span>
                    </p>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" md="1"> </v-col>
                  <v-col cols="12" md="8">
                    <p class="subtitle-1 text-left">
                      Vous êtes pharmacien titulaire d’officine (A ou E) ou
                      gérant d’une pharmacie mutualiste ou minière (D) depuis au
                      moins 2 années :
                    </p>
                    <v-radio-group v-model="titulaire" row>
                      <v-radio label="Oui" v-bind:value="true"></v-radio>
                      <v-radio label="Non" v-bind:value="false"></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" md="1"> </v-col>
                  <v-col cols="12" md="8">
                    <p class="subtitle-1 text-left">
                      Vous justifiez de 5 années d’exercice officinal :
                    </p>
                    <v-radio-group v-model="anciennete" row>
                      <v-radio label="Oui" v-bind:value="true"></v-radio>
                      <v-radio label="Non" v-bind:value="false"></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" md="1"> </v-col>
                  <v-col cols="12" md="8">
                    <CaptchaWidget :cimage="captcha.captchaImage" :cvalue.sync="captcha.captchaValue" />
                  </v-col>
                </v-row>
              </div>
              <v-row>
                <v-col cols="12" md="1"> </v-col>
                <v-col cols="12" md="11">
                  <v-btn :disabled="!isFormValid()" color="blue" class="mr-4 white--text" :loading="onRequestAttempt"
                    @click="submit">
                    Demander l'accès à la demande d'agrément**
                  </v-btn>
                  <p class="text-sm-left body-2 font-italic">
                    ** un lien d'accès vers une nouvelle demande d'agrément vous
                    sera envoyé par courriel
                  </p>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </BaseBlock>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import BaseBlock from "@/components/base/BaseBlock";
import CaptchaWidget from "@/components/CaptchaWidget";
import ApiDossierRepository from "@/repositories/ApiDossierRepository";

export default {
  name: "DemandeAcces",
  components: { BaseBlock, CaptchaWidget },
  data: () => ({
    componentKey: 0,
    dialogCreated: false,
    avertissement: false,
    valid: false,
    onRequestAttempt: false,
    isConditionsExperience: true,
    nom: "",
    prenom: "",
    email: "",
    siret: "",
    nomRules: [v => (!!v && !!v.trim()) || "Votre nom est requis"],
    prenomRules: [v => (!!v && !!v.trim()) || "Votre prénom est requis"],
    siretRules: [
      v => !!v || "Le numéro de SIRET est requis",
      v =>
        (v && v.length == 14) ||
        "Le numéro de SIRET est composé de 14 chiffres (sans espace)",
      v =>
        /^-?([0-9]\d*\.?\d*)$/.test(v) ||
        "Le numéro de SIRET est composé uniquement de chiffres"
    ],
    emailRules: [
      v => !!v || "Une adresse de courriel est requise",
      v => /.+@.+\..+/.test(v) || "L'adresse de courriel doit être valide",
      v =>
        v.trim().indexOf(" ") == -1 || "L'adresse de courriel doit être valide"
    ],
    titulaire: null,
    anciennete: null,
    captchaData: null
  }),
  async mounted() {
    this.captchaData = await ApiDossierRepository.getDossierCaptcha();
  },
  computed: {
    isServiceIndisponible() {
      const dateLimit = new Date('2026-03-16T00:00:00');
      const dateActuelle = new Date();
      return dateActuelle >= dateLimit;
    },
    captcha() {
      if (this.captchaData) return this.captchaData;
      return { captchaValue: null, captchaSecret: null, captchaImage: null };
    }
  },
  methods: {
    isFormValid() {
      if (!this.valid) return false;
      if (this.titulaire == null) {
        this.isConditionsExperience = true;
        return false;
      }
      if (this.anciennete == null) {
        this.isConditionsExperience = true;
        return false;
      }
      if (!this.titulaire) {
        this.isConditionsExperience = false;
        return false;
      }
      if (!this.anciennete) {
        this.isConditionsExperience = false;
        return false;
      }
      this.isConditionsExperience = true;
      return true;
    },
    validateSIRET() {
      var estValide;
      if (this.siret.length != 14 || isNaN(this.siret)) estValide = false;
      else {
        // Donc le SIRET est un numérique à 14 chiffres
        // Les 9 premiers chiffres sont ceux du SIREN (ou RCS), les 4 suivants
        // correspondent au numéro d'établissement
        // et enfin le dernier chiffre est une clef de LUHN.
        var somme = 0;
        var tmp;
        for (var cpt = 0; cpt < this.siret.length; cpt++) {
          if (cpt % 2 == 0) {
            // Les positions impaires : 1er, 3è, 5è, etc...
            tmp = this.siret.charAt(cpt) * 2; // On le multiplie par 2
            if (tmp > 9) tmp -= 9; // Si le résultat est supérieur à 9, on lui soustrait 9
          } else tmp = this.siret.charAt(cpt);
          somme += parseInt(tmp);
        }
        if (somme % 10 == 0) estValide = true;
        // Si la somme est un multiple de 10 alors le SIRET est valide
        else estValide = false;
      }
      return estValide;
    },
    async submit() {
      // on valide le SIRET via une méthode de calcul avant de contacter le WS de l'INSEE
      if (!this.validateSIRET()) {
        this.$toast.error(
          "Le numéro de SIRET que vous avez renseigné n'est pas valide"
        );
      } else {
        this.onRequestAttempt = true;
        const newDossier = {
          contactNom: this.nom.trim(),
          contactPrenom: this.prenom.trim(),
          contactMail: this.email.trim(),
          officine: {
            siret: this.siret.trim()
          },
          officineSiret: this.siret.trim(),
          anciennete: this.anciennete,
          titulaire: this.titulaire,
          etat: { id: 1 },
          captchaValue: this.captchaData.captchaValue
        };
        const response = await ApiDossierRepository.create(newDossier);
        if (response.status >= 400) {
          if (response.request != undefined) {
            let messageErreur = JSON.parse(response.request.response);

            if (messageErreur.fieldErrors != undefined) {
              this.$toast.error(
                "Votre demande ne peut aboutir : " +
                messageErreur.fieldErrors[0].message
              );
            } else {
              this.$toast.error(
                "Votre demande ne peut aboutir : " + messageErreur.messages[0]
              );
            }
          } else if (response.messages != undefined) {
            this.$toast.error(
              "Votre demande ne peut aboutir : " + response.messages[0]
            );
          }
          this.captchaData = await ApiDossierRepository.getDossierCaptcha();
        } else {
          this.dialogCreated = true;
        }
        this.onRequestAttempt = false;
      }
    },
    clearForm() {
      this.$router.go(0);
      this.email = this.nom = this.prenom = this.siret = "";
      this.$refs.form.resetValidation();
    }
  }
};
</script>
